import { render, staticRenderFns } from "./MemberView.vue?vue&type=template&id=5276702a&scoped=true&"
import script from "./MemberView.vue?vue&type=script&lang=js&"
export * from "./MemberView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5276702a",
  null
  
)

export default component.exports